/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jquery_scrollex_min__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jquery_scrollex_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__jquery_scrollex_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jquery_scrolly_min__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jquery_scrolly_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__jquery_scrolly_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skel_min__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skel_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__skel_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sass_main_scss__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sass_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sass_main_scss__);
/*
	Story by HTML5 UP
	html5up.net | @ajlkn
	Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
*/




window.skel = __WEBPACK_IMPORTED_MODULE_2__skel_min___default.a;


(function ($) {

	__WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.breakpoints({
		xlarge: '(max-width: 1680px)',
		large: '(max-width: 1280px)',
		medium: '(max-width: 980px)',
		small: '(max-width: 736px)',
		xsmall: '(max-width: 480px)',
		xxsmall: '(max-width: 360px)'
	});

	$(function () {

		var $window = $(window),
		    $body = $('body'),
		    $wrapper = $('#wrapper');

		// Disable animations/transitions until the page has loaded.
		$body.addClass('is-loading');

		$window.on('load', function () {
			window.setTimeout(function () {
				$body.removeClass('is-loading');
			}, 100);
		});

		// Fix: Placeholder polyfill.
		$('form').placeholder();

		// Prioritize "important" elements on medium.
		__WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.on('+medium -medium', function () {
			$.prioritize('.important\\28 medium\\29', __WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.breakpoint('medium').active);
		});

		// Browser fixes.

		// IE: Flexbox min-height bug.
		if (__WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.vars.browser == 'ie') (function () {

			var flexboxFixTimeoutId;

			$window.on('resize.flexbox-fix', function () {

				var $x = $('.fullscreen');

				clearTimeout(flexboxFixTimeoutId);

				flexboxFixTimeoutId = setTimeout(function () {

					if ($x.prop('scrollHeight') > $window.height()) $x.css('height', 'auto');else $x.css('height', '100vh');
				}, 250);
			}).triggerHandler('resize.flexbox-fix');
		})();

		// Object fit workaround.
		if (!__WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.canUse('object-fit')) (function () {

			$('.banner .image, .spotlight .image').each(function () {

				var $this = $(this),
				    $img = $this.children('img'),
				    positionClass = $this.parent().attr('class').match(/image-position-([a-z]+)/);

				// Set image.
				$this.css('background-image', 'url("' + $img.attr('src') + '")').css('background-repeat', 'no-repeat').css('background-size', 'cover');

				// Set position.
				switch (positionClass.length > 1 ? positionClass[1] : '') {

					case 'left':
						$this.css('background-position', 'left');
						break;

					case 'right':
						$this.css('background-position', 'right');
						break;

					default:
					case 'center':
						$this.css('background-position', 'center');
						break;

				}

				// Hide original.
				$img.css('opacity', '0');
			});
		})();

		// Smooth scroll.
		$('.smooth-scroll').scrolly();
		$('.smooth-scroll-middle').scrolly({ anchor: 'middle' });

		// Wrapper.
		$wrapper.children().scrollex({
			top: '30vh',
			bottom: '30vh',
			initialize: function () {
				$(this).addClass('is-inactive');
			},
			terminate: function () {
				$(this).removeClass('is-inactive');
			},
			enter: function () {
				$(this).removeClass('is-inactive');
			},
			leave: function () {

				var $this = $(this);

				if ($this.hasClass('onscroll-bidirectional')) $this.addClass('is-inactive');
			}
		});

		// Items.
		$('.items').scrollex({
			top: '30vh',
			bottom: '30vh',
			delay: 50,
			initialize: function () {
				$(this).addClass('is-inactive');
			},
			terminate: function () {
				$(this).removeClass('is-inactive');
			},
			enter: function () {
				$(this).removeClass('is-inactive');
			},
			leave: function () {

				var $this = $(this);

				if ($this.hasClass('onscroll-bidirectional')) $this.addClass('is-inactive');
			}
		}).children().wrapInner('<div class="inner"></div>');

		// Gallery.
		$('.gallery').wrapInner('<div class="inner"></div>').prepend(__WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.vars.mobile ? '' : '<div class="forward"></div><div class="backward"></div>').scrollex({
			top: '30vh',
			bottom: '30vh',
			delay: 50,
			initialize: function () {
				$(this).addClass('is-inactive');
			},
			terminate: function () {
				$(this).removeClass('is-inactive');
			},
			enter: function () {
				$(this).removeClass('is-inactive');
			},
			leave: function () {

				var $this = $(this);

				if ($this.hasClass('onscroll-bidirectional')) $this.addClass('is-inactive');
			}
		}).children('.inner')
		//.css('overflow', 'hidden')
		.css('overflow-y', __WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.vars.mobile ? 'visible' : 'hidden').css('overflow-x', __WEBPACK_IMPORTED_MODULE_2__skel_min___default.a.vars.mobile ? 'scroll' : 'hidden').scrollLeft(0);

		// Style #1.
		// ...

		// Style #2.
		$('.gallery').on('wheel', '.inner', function (event) {

			var $this = $(this),
			    delta = event.originalEvent.deltaX * 10;

			// Cap delta.
			if (delta > 0) delta = Math.min(25, delta);else if (delta < 0) delta = Math.max(-25, delta);

			// Scroll.
			$this.scrollLeft($this.scrollLeft() + delta);
		}).on('mouseenter', '.forward, .backward', function (event) {

			var $this = $(this),
			    $inner = $this.siblings('.inner'),
			    direction = $this.hasClass('forward') ? 1 : -1;

			// Clear move interval.
			clearInterval(this._gallery_moveIntervalId);

			// Start interval.
			this._gallery_moveIntervalId = setInterval(function () {
				$inner.scrollLeft($inner.scrollLeft() + 5 * direction);
			}, 10);
		}).on('mouseleave', '.forward, .backward', function (event) {

			// Clear move interval.
			clearInterval(this._gallery_moveIntervalId);
		});

		// Lightbox.
		$('.gallery.lightbox').on('click', 'a', function (event) {

			var $a = $(this),
			    $gallery = $a.parents('.gallery'),
			    $modal = $gallery.children('.modal'),
			    $modalImg = $modal.find('img'),
			    href = $a.attr('href');

			// Not an image? Bail.
			if (!href.match(/\.(jpg|gif|png|mp4)$/)) return;

			// Prevent default.
			event.preventDefault();
			event.stopPropagation();

			// Locked? Bail.
			if ($modal[0]._locked) return;

			// Lock.
			$modal[0]._locked = true;

			// Set src.
			$modalImg.attr('src', href);

			// Set visible.
			$modal.addClass('visible');

			// Focus.
			$modal.focus();

			// Delay.
			setTimeout(function () {

				// Unlock.
				$modal[0]._locked = false;
			}, 600);
		}).on('click', '.modal', function (event) {

			var $modal = $(this),
			    $modalImg = $modal.find('img');

			// Locked? Bail.
			if ($modal[0]._locked) return;

			// Already hidden? Bail.
			if (!$modal.hasClass('visible')) return;

			// Lock.
			$modal[0]._locked = true;

			// Clear visible, loaded.
			$modal.removeClass('loaded');

			// Delay.
			setTimeout(function () {

				$modal.removeClass('visible');

				setTimeout(function () {

					// Clear src.
					$modalImg.attr('src', '');

					// Unlock.
					$modal[0]._locked = false;

					// Focus.
					$body.focus();
				}, 475);
			}, 125);
		}).on('keypress', '.modal', function (event) {

			var $modal = $(this);

			// Escape? Hide modal.
			if (event.keyCode == 27) $modal.trigger('click');
		}).prepend('<div class="modal" tabIndex="-1"><div class="inner"><img src="" /></div></div>').find('img').on('load', function (event) {

			var $modalImg = $(this),
			    $modal = $modalImg.parents('.modal');

			setTimeout(function () {

				// No longer visible? Bail.
				if (!$modal.hasClass('visible')) return;

				// Set loaded.
				$modal.addClass('loaded');
			}, 275);
		});
	});
})(jQuery);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* jquery.scrollex v0.2.1 | (c) @ajlkn | github.com/ajlkn/jquery.scrollex | MIT licensed */
!function (t) {
  function e(t, e, n) {
    return "string" == typeof t && ("%" == t.slice(-1) ? t = parseInt(t.substring(0, t.length - 1)) / 100 * e : "vh" == t.slice(-2) ? t = parseInt(t.substring(0, t.length - 2)) / 100 * n : "px" == t.slice(-2) && (t = parseInt(t.substring(0, t.length - 2)))), t;
  }var n = t(window),
      i = 1,
      o = {};n.on("scroll", function () {
    var e = n.scrollTop();t.map(o, function (t) {
      window.clearTimeout(t.timeoutId), t.timeoutId = window.setTimeout(function () {
        t.handler(e);
      }, t.options.delay);
    });
  }).on("load", function () {
    n.trigger("scroll");
  }), jQuery.fn.scrollex = function (l) {
    var s = t(this);if (0 == this.length) return s;if (this.length > 1) {
      for (var r = 0; r < this.length; r++) t(this[r]).scrollex(l);return s;
    }if (s.data("_scrollexId")) return s;var a, u, h, c, p;switch (a = i++, u = jQuery.extend({ top: 0, bottom: 0, delay: 0, mode: "default", enter: null, leave: null, initialize: null, terminate: null, scroll: null }, l), u.mode) {case "top":
        h = function (t, e, n, i, o) {
          return t >= i && o >= t;
        };break;case "bottom":
        h = function (t, e, n, i, o) {
          return n >= i && o >= n;
        };break;case "middle":
        h = function (t, e, n, i, o) {
          return e >= i && o >= e;
        };break;case "top-only":
        h = function (t, e, n, i, o) {
          return i >= t && n >= i;
        };break;case "bottom-only":
        h = function (t, e, n, i, o) {
          return n >= o && o >= t;
        };break;default:case "default":
        h = function (t, e, n, i, o) {
          return n >= i && o >= t;
        };}return c = function (t) {
      var i,
          o,
          l,
          s,
          r,
          a,
          u = this.state,
          h = !1,
          c = this.$element.offset();i = n.height(), o = t + i / 2, l = t + i, s = this.$element.outerHeight(), r = c.top + e(this.options.top, s, i), a = c.top + s - e(this.options.bottom, s, i), h = this.test(t, o, l, r, a), h != u && (this.state = h, h ? this.options.enter && this.options.enter.apply(this.element) : this.options.leave && this.options.leave.apply(this.element)), this.options.scroll && this.options.scroll.apply(this.element, [(o - r) / (a - r)]);
    }, p = { id: a, options: u, test: h, handler: c, state: null, element: this, $element: s, timeoutId: null }, o[a] = p, s.data("_scrollexId", p.id), p.options.initialize && p.options.initialize.apply(this), s;
  }, jQuery.fn.unscrollex = function () {
    var e = t(this);if (0 == this.length) return e;if (this.length > 1) {
      for (var n = 0; n < this.length; n++) t(this[n]).unscrollex();return e;
    }var i, l;return (i = e.data("_scrollexId")) ? (l = o[i], window.clearTimeout(l.timeoutId), delete o[i], e.removeData("_scrollexId"), l.options.terminate && l.options.terminate.apply(this), e) : e;
  };
}(jQuery);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* jquery.scrolly v1.0.0-dev | (c) @ajlkn | MIT licensed */
(function (e) {
  function u(s, o) {
    var u, a, f;if ((u = e(s))[t] == 0) return n;a = u[i]()[r];switch (o.anchor) {case "middle":
        f = a - (e(window).height() - u.outerHeight()) / 2;break;default:case r:
        f = Math.max(a, 0);}return typeof o[i] == "function" ? f -= o[i]() : f -= o[i], f;
  }var t = "length",
      n = null,
      r = "top",
      i = "offset",
      s = "click.scrolly",
      o = e(window);e.fn.scrolly = function (i) {
    var o,
        a,
        f,
        l,
        c = e(this);if (this[t] == 0) return c;if (this[t] > 1) {
      for (o = 0; o < this[t]; o++) e(this[o]).scrolly(i);return c;
    }l = n, f = c.attr("href");if (f.charAt(0) != "#" || f[t] < 2) return c;a = jQuery.extend({ anchor: r, easing: "swing", offset: 0, parent: e("body,html"), pollOnce: !1, speed: 1e3 }, i), a.pollOnce && (l = u(f, a)), c.off(s).on(s, function (e) {
      var t = l !== n ? l : u(f, a);t !== n && (e.preventDefault(), a.parent.stop().animate({ scrollTop: t }, a.speed, a.easing));
    });
  };
})(jQuery);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* skel.js v3.0.1 | (c) skel.io | MIT licensed */
var skel = function () {
  "use strict";
  var t = { breakpointIds: null, events: {}, isInit: !1, obj: { attachments: {}, breakpoints: {}, head: null, states: {} }, sd: "/", state: null, stateHandlers: {}, stateId: "", vars: {}, DOMReady: null, indexOf: null, isArray: null, iterate: null, matchesMedia: null, extend: function (e, n) {
      t.iterate(n, function (i) {
        t.isArray(n[i]) ? (t.isArray(e[i]) || (e[i] = []), t.extend(e[i], n[i])) : "object" == typeof n[i] ? ("object" != typeof e[i] && (e[i] = {}), t.extend(e[i], n[i])) : e[i] = n[i];
      });
    }, newStyle: function (t) {
      var e = document.createElement("style");return e.type = "text/css", e.innerHTML = t, e;
    }, _canUse: null, canUse: function (e) {
      t._canUse || (t._canUse = document.createElement("div"));var n = t._canUse.style,
          i = e.charAt(0).toUpperCase() + e.slice(1);return e in n || "Moz" + i in n || "Webkit" + i in n || "O" + i in n || "ms" + i in n;
    }, on: function (e, n) {
      var i = e.split(/[\s]+/);return t.iterate(i, function (e) {
        var a = i[e];if (t.isInit) {
          if ("init" == a) return void n();if ("change" == a) n();else {
            var r = a.charAt(0);if ("+" == r || "!" == r) {
              var o = a.substring(1);if (o in t.obj.breakpoints) if ("+" == r && t.obj.breakpoints[o].active) n();else if ("!" == r && !t.obj.breakpoints[o].active) return void n();
            }
          }
        }t.events[a] || (t.events[a] = []), t.events[a].push(n);
      }), t;
    }, trigger: function (e) {
      return t.events[e] && 0 != t.events[e].length ? (t.iterate(t.events[e], function (n) {
        t.events[e][n]();
      }), t) : void 0;
    }, breakpoint: function (e) {
      return t.obj.breakpoints[e];
    }, breakpoints: function (e) {
      function n(t, e) {
        this.name = this.id = t, this.media = e, this.active = !1, this.wasActive = !1;
      }return n.prototype.matches = function () {
        return t.matchesMedia(this.media);
      }, n.prototype.sync = function () {
        this.wasActive = this.active, this.active = this.matches();
      }, t.iterate(e, function (i) {
        t.obj.breakpoints[i] = new n(i, e[i]);
      }), window.setTimeout(function () {
        t.poll();
      }, 0), t;
    }, addStateHandler: function (e, n) {
      t.stateHandlers[e] = n;
    }, callStateHandler: function (e) {
      var n = t.stateHandlers[e]();t.iterate(n, function (e) {
        t.state.attachments.push(n[e]);
      });
    }, changeState: function (e) {
      t.iterate(t.obj.breakpoints, function (e) {
        t.obj.breakpoints[e].sync();
      }), t.vars.lastStateId = t.stateId, t.stateId = e, t.breakpointIds = t.stateId === t.sd ? [] : t.stateId.substring(1).split(t.sd), t.obj.states[t.stateId] ? t.state = t.obj.states[t.stateId] : (t.obj.states[t.stateId] = { attachments: [] }, t.state = t.obj.states[t.stateId], t.iterate(t.stateHandlers, t.callStateHandler)), t.detachAll(t.state.attachments), t.attachAll(t.state.attachments), t.vars.stateId = t.stateId, t.vars.state = t.state, t.trigger("change"), t.iterate(t.obj.breakpoints, function (e) {
        t.obj.breakpoints[e].active ? t.obj.breakpoints[e].wasActive || t.trigger("+" + e) : t.obj.breakpoints[e].wasActive && t.trigger("-" + e);
      });
    }, generateStateConfig: function (e, n) {
      var i = {};return t.extend(i, e), t.iterate(t.breakpointIds, function (e) {
        t.extend(i, n[t.breakpointIds[e]]);
      }), i;
    }, getStateId: function () {
      var e = "";return t.iterate(t.obj.breakpoints, function (n) {
        var i = t.obj.breakpoints[n];i.matches() && (e += t.sd + i.id);
      }), e;
    }, poll: function () {
      var e = "";e = t.getStateId(), "" === e && (e = t.sd), e !== t.stateId && t.changeState(e);
    }, _attach: null, attach: function (e) {
      var n = t.obj.head,
          i = e.element;return i.parentNode && i.parentNode.tagName ? !1 : (t._attach || (t._attach = n.firstChild), n.insertBefore(i, t._attach.nextSibling), e.permanent && (t._attach = i), !0);
    }, attachAll: function (e) {
      var n = [];t.iterate(e, function (t) {
        n[e[t].priority] || (n[e[t].priority] = []), n[e[t].priority].push(e[t]);
      }), n.reverse(), t.iterate(n, function (e) {
        t.iterate(n[e], function (i) {
          t.attach(n[e][i]);
        });
      });
    }, detach: function (t) {
      var e = t.element;return t.permanent || !e.parentNode || e.parentNode && !e.parentNode.tagName ? !1 : (e.parentNode.removeChild(e), !0);
    }, detachAll: function (e) {
      var n = {};t.iterate(e, function (t) {
        n[e[t].id] = !0;
      }), t.iterate(t.obj.attachments, function (e) {
        e in n || t.detach(t.obj.attachments[e]);
      });
    }, attachment: function (e) {
      return e in t.obj.attachments ? t.obj.attachments[e] : null;
    }, newAttachment: function (e, n, i, a) {
      return t.obj.attachments[e] = { id: e, element: n, priority: i, permanent: a };
    }, init: function () {
      t.initMethods(), t.initVars(), t.initEvents(), t.obj.head = document.getElementsByTagName("head")[0], t.isInit = !0, t.trigger("init");
    }, initEvents: function () {
      t.on("resize", function () {
        t.poll();
      }), t.on("orientationChange", function () {
        t.poll();
      }), t.DOMReady(function () {
        t.trigger("ready");
      }), window.onload && t.on("load", window.onload), window.onload = function () {
        t.trigger("load");
      }, window.onresize && t.on("resize", window.onresize), window.onresize = function () {
        t.trigger("resize");
      }, window.onorientationchange && t.on("orientationChange", window.onorientationchange), window.onorientationchange = function () {
        t.trigger("orientationChange");
      };
    }, initMethods: function () {
      document.addEventListener ? !function (e, n) {
        t.DOMReady = n();
      }("domready", function () {
        function t(t) {
          for (r = 1; t = n.shift();) t();
        }var e,
            n = [],
            i = document,
            a = "DOMContentLoaded",
            r = /^loaded|^c/.test(i.readyState);return i.addEventListener(a, e = function () {
          i.removeEventListener(a, e), t();
        }), function (t) {
          r ? t() : n.push(t);
        };
      }) : !function (e, n) {
        t.DOMReady = n();
      }("domready", function (t) {
        function e(t) {
          for (h = 1; t = i.shift();) t();
        }var n,
            i = [],
            a = !1,
            r = document,
            o = r.documentElement,
            s = o.doScroll,
            c = "DOMContentLoaded",
            d = "addEventListener",
            u = "onreadystatechange",
            l = "readyState",
            f = s ? /^loaded|^c/ : /^loaded|c/,
            h = f.test(r[l]);return r[d] && r[d](c, n = function () {
          r.removeEventListener(c, n, a), e();
        }, a), s && r.attachEvent(u, n = function () {
          /^c/.test(r[l]) && (r.detachEvent(u, n), e());
        }), t = s ? function (e) {
          self != top ? h ? e() : i.push(e) : function () {
            try {
              o.doScroll("left");
            } catch (n) {
              return setTimeout(function () {
                t(e);
              }, 50);
            }e();
          }();
        } : function (t) {
          h ? t() : i.push(t);
        };
      }), Array.prototype.indexOf ? t.indexOf = function (t, e) {
        return t.indexOf(e);
      } : t.indexOf = function (t, e) {
        if ("string" == typeof t) return t.indexOf(e);var n,
            i,
            a = e ? e : 0;if (!this) throw new TypeError();if (i = this.length, 0 === i || a >= i) return -1;for (0 > a && (a = i - Math.abs(a)), n = a; i > n; n++) if (this[n] === t) return n;return -1;
      }, Array.isArray ? t.isArray = function (t) {
        return Array.isArray(t);
      } : t.isArray = function (t) {
        return "[object Array]" === Object.prototype.toString.call(t);
      }, Object.keys ? t.iterate = function (t, e) {
        if (!t) return [];var n,
            i = Object.keys(t);for (n = 0; i[n] && e(i[n], t[i[n]]) !== !1; n++);
      } : t.iterate = function (t, e) {
        if (!t) return [];var n;for (n in t) if (Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]) === !1) break;
      }, window.matchMedia ? t.matchesMedia = function (t) {
        return "" == t ? !0 : window.matchMedia(t).matches;
      } : window.styleMedia || window.media ? t.matchesMedia = function (t) {
        if ("" == t) return !0;var e = window.styleMedia || window.media;return e.matchMedium(t || "all");
      } : window.getComputedStyle ? t.matchesMedia = function (t) {
        if ("" == t) return !0;var e = document.createElement("style"),
            n = document.getElementsByTagName("script")[0],
            i = null;e.type = "text/css", e.id = "matchmediajs-test", n.parentNode.insertBefore(e, n), i = "getComputedStyle" in window && window.getComputedStyle(e, null) || e.currentStyle;var a = "@media " + t + "{ #matchmediajs-test { width: 1px; } }";return e.styleSheet ? e.styleSheet.cssText = a : e.textContent = a, "1px" === i.width;
      } : t.matchesMedia = function (t) {
        if ("" == t) return !0;var e,
            n,
            i,
            a,
            r = { "min-width": null, "max-width": null },
            o = !1;for (i = t.split(/\s+and\s+/), e = 0; e < i.length; e++) n = i[e], "(" == n.charAt(0) && (n = n.substring(1, n.length - 1), a = n.split(/:\s+/), 2 == a.length && (r[a[0].replace(/^\s+|\s+$/g, "")] = parseInt(a[1]), o = !0));if (!o) return !1;var s = document.documentElement.clientWidth,
            c = document.documentElement.clientHeight;return null !== r["min-width"] && s < r["min-width"] || null !== r["max-width"] && s > r["max-width"] || null !== r["min-height"] && c < r["min-height"] || null !== r["max-height"] && c > r["max-height"] ? !1 : !0;
      }, navigator.userAgent.match(/MSIE ([0-9]+)/) && RegExp.$1 < 9 && (t.newStyle = function (t) {
        var e = document.createElement("span");return e.innerHTML = '&nbsp;<style type="text/css">' + t + "</style>", e;
      });
    }, initVars: function () {
      var e,
          n,
          i,
          a = navigator.userAgent;e = "other", n = 0, i = [["firefox", /Firefox\/([0-9\.]+)/], ["bb", /BlackBerry.+Version\/([0-9\.]+)/], ["bb", /BB[0-9]+.+Version\/([0-9\.]+)/], ["opera", /OPR\/([0-9\.]+)/], ["opera", /Opera\/([0-9\.]+)/], ["edge", /Edge\/([0-9\.]+)/], ["safari", /Version\/([0-9\.]+).+Safari/], ["chrome", /Chrome\/([0-9\.]+)/], ["ie", /MSIE ([0-9]+)/], ["ie", /Trident\/.+rv:([0-9]+)/]], t.iterate(i, function (t, i) {
        return a.match(i[1]) ? (e = i[0], n = parseFloat(RegExp.$1), !1) : void 0;
      }), t.vars.browser = e, t.vars.browserVersion = n, e = "other", n = 0, i = [["ios", /([0-9_]+) like Mac OS X/, function (t) {
        return t.replace("_", ".").replace("_", "");
      }], ["ios", /CPU like Mac OS X/, function (t) {
        return 0;
      }], ["wp", /Windows Phone ([0-9\.]+)/, null], ["android", /Android ([0-9\.]+)/, null], ["mac", /Macintosh.+Mac OS X ([0-9_]+)/, function (t) {
        return t.replace("_", ".").replace("_", "");
      }], ["windows", /Windows NT ([0-9\.]+)/, null], ["bb", /BlackBerry.+Version\/([0-9\.]+)/, null], ["bb", /BB[0-9]+.+Version\/([0-9\.]+)/, null]], t.iterate(i, function (t, i) {
        return a.match(i[1]) ? (e = i[0], n = parseFloat(i[2] ? i[2](RegExp.$1) : RegExp.$1), !1) : void 0;
      }), t.vars.os = e, t.vars.osVersion = n, t.vars.IEVersion = "ie" == t.vars.browser ? t.vars.browserVersion : 99, t.vars.touch = "wp" == t.vars.os ? navigator.msMaxTouchPoints > 0 : !!("ontouchstart" in window), t.vars.mobile = "wp" == t.vars.os || "android" == t.vars.os || "ios" == t.vars.os || "bb" == t.vars.os;
    } };return t.init(), t;
}();!function (t, e) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = e() : t.skel = e();
}(this, function () {
  return skel;
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

(function ($) {

	/**
  * Generate an indented list of links from a nav. Meant for use with panel().
  * @return {jQuery} jQuery object.
  */
	$.fn.navList = function () {

		var $this = $(this);
		$a = $this.find('a'), b = [];

		$a.each(function () {

			var $this = $(this),
			    indent = Math.max(0, $this.parents('li').length - 1),
			    href = $this.attr('href'),
			    target = $this.attr('target');

			b.push('<a ' + 'class="link depth-' + indent + '"' + (typeof target !== 'undefined' && target != '' ? ' target="' + target + '"' : '') + (typeof href !== 'undefined' && href != '' ? ' href="' + href + '"' : '') + '>' + '<span class="indent-' + indent + '"></span>' + $this.text() + '</a>');
		});

		return b.join('');
	};

	/**
  * Panel-ify an element.
  * @param {object} userConfig User config.
  * @return {jQuery} jQuery object.
  */
	$.fn.panel = function (userConfig) {

		// No elements?
		if (this.length == 0) return $this;

		// Multiple elements?
		if (this.length > 1) {

			for (var i = 0; i < this.length; i++) $(this[i]).panel(userConfig);

			return $this;
		}

		// Vars.
		var $this = $(this),
		    $body = $('body'),
		    $window = $(window),
		    id = $this.attr('id'),
		    config;

		// Config.
		config = $.extend({

			// Delay.
			delay: 0,

			// Hide panel on link click.
			hideOnClick: false,

			// Hide panel on escape keypress.
			hideOnEscape: false,

			// Hide panel on swipe.
			hideOnSwipe: false,

			// Reset scroll position on hide.
			resetScroll: false,

			// Reset forms on hide.
			resetForms: false,

			// Side of viewport the panel will appear.
			side: null,

			// Target element for "class".
			target: $this,

			// Class to toggle.
			visibleClass: 'visible'

		}, userConfig);

		// Expand "target" if it's not a jQuery object already.
		if (typeof config.target != 'jQuery') config.target = $(config.target);

		// Panel.

		// Methods.
		$this._hide = function (event) {

			// Already hidden? Bail.
			if (!config.target.hasClass(config.visibleClass)) return;

			// If an event was provided, cancel it.
			if (event) {

				event.preventDefault();
				event.stopPropagation();
			}

			// Hide.
			config.target.removeClass(config.visibleClass);

			// Post-hide stuff.
			window.setTimeout(function () {

				// Reset scroll position.
				if (config.resetScroll) $this.scrollTop(0);

				// Reset forms.
				if (config.resetForms) $this.find('form').each(function () {
					this.reset();
				});
			}, config.delay);
		};

		// Vendor fixes.
		$this.css('-ms-overflow-style', '-ms-autohiding-scrollbar').css('-webkit-overflow-scrolling', 'touch');

		// Hide on click.
		if (config.hideOnClick) {

			$this.find('a').css('-webkit-tap-highlight-color', 'rgba(0,0,0,0)');

			$this.on('click', 'a', function (event) {

				var $a = $(this),
				    href = $a.attr('href'),
				    target = $a.attr('target');

				if (!href || href == '#' || href == '' || href == '#' + id) return;

				// Cancel original event.
				event.preventDefault();
				event.stopPropagation();

				// Hide panel.
				$this._hide();

				// Redirect to href.
				window.setTimeout(function () {

					if (target == '_blank') window.open(href);else window.location.href = href;
				}, config.delay + 10);
			});
		}

		// Event: Touch stuff.
		$this.on('touchstart', function (event) {

			$this.touchPosX = event.originalEvent.touches[0].pageX;
			$this.touchPosY = event.originalEvent.touches[0].pageY;
		});

		$this.on('touchmove', function (event) {

			if ($this.touchPosX === null || $this.touchPosY === null) return;

			var diffX = $this.touchPosX - event.originalEvent.touches[0].pageX,
			    diffY = $this.touchPosY - event.originalEvent.touches[0].pageY,
			    th = $this.outerHeight(),
			    ts = $this.get(0).scrollHeight - $this.scrollTop();

			// Hide on swipe?
			if (config.hideOnSwipe) {

				var result = false,
				    boundary = 20,
				    delta = 50;

				switch (config.side) {

					case 'left':
						result = diffY < boundary && diffY > -1 * boundary && diffX > delta;
						break;

					case 'right':
						result = diffY < boundary && diffY > -1 * boundary && diffX < -1 * delta;
						break;

					case 'top':
						result = diffX < boundary && diffX > -1 * boundary && diffY > delta;
						break;

					case 'bottom':
						result = diffX < boundary && diffX > -1 * boundary && diffY < -1 * delta;
						break;

					default:
						break;

				}

				if (result) {

					$this.touchPosX = null;
					$this.touchPosY = null;
					$this._hide();

					return false;
				}
			}

			// Prevent vertical scrolling past the top or bottom.
			if ($this.scrollTop() < 0 && diffY < 0 || ts > th - 2 && ts < th + 2 && diffY > 0) {

				event.preventDefault();
				event.stopPropagation();
			}
		});

		// Event: Prevent certain events inside the panel from bubbling.
		$this.on('click touchend touchstart touchmove', function (event) {
			event.stopPropagation();
		});

		// Event: Hide panel if a child anchor tag pointing to its ID is clicked.
		$this.on('click', 'a[href="#' + id + '"]', function (event) {

			event.preventDefault();
			event.stopPropagation();

			config.target.removeClass(config.visibleClass);
		});

		// Body.

		// Event: Hide panel on body click/tap.
		$body.on('click touchend', function (event) {
			$this._hide(event);
		});

		// Event: Toggle.
		$body.on('click', 'a[href="#' + id + '"]', function (event) {

			event.preventDefault();
			event.stopPropagation();

			config.target.toggleClass(config.visibleClass);
		});

		// Window.

		// Event: Hide on ESC.
		if (config.hideOnEscape) $window.on('keydown', function (event) {

			if (event.keyCode == 27) $this._hide(event);
		});

		return $this;
	};

	/**
  * Apply "placeholder" attribute polyfill to one or more forms.
  * @return {jQuery} jQuery object.
  */
	$.fn.placeholder = function () {

		// Browser natively supports placeholders? Bail.
		if (typeof document.createElement('input').placeholder != 'undefined') return $(this);

		// No elements?
		if (this.length == 0) return $this;

		// Multiple elements?
		if (this.length > 1) {

			for (var i = 0; i < this.length; i++) $(this[i]).placeholder();

			return $this;
		}

		// Vars.
		var $this = $(this);

		// Text, TextArea.
		$this.find('input[type=text],textarea').each(function () {

			var i = $(this);

			if (i.val() == '' || i.val() == i.attr('placeholder')) i.addClass('polyfill-placeholder').val(i.attr('placeholder'));
		}).on('blur', function () {

			var i = $(this);

			if (i.attr('name').match(/-polyfill-field$/)) return;

			if (i.val() == '') i.addClass('polyfill-placeholder').val(i.attr('placeholder'));
		}).on('focus', function () {

			var i = $(this);

			if (i.attr('name').match(/-polyfill-field$/)) return;

			if (i.val() == i.attr('placeholder')) i.removeClass('polyfill-placeholder').val('');
		});

		// Password.
		$this.find('input[type=password]').each(function () {

			var i = $(this);
			var x = $($('<div>').append(i.clone()).remove().html().replace(/type="password"/i, 'type="text"').replace(/type=password/i, 'type=text'));

			if (i.attr('id') != '') x.attr('id', i.attr('id') + '-polyfill-field');

			if (i.attr('name') != '') x.attr('name', i.attr('name') + '-polyfill-field');

			x.addClass('polyfill-placeholder').val(x.attr('placeholder')).insertAfter(i);

			if (i.val() == '') i.hide();else x.hide();

			i.on('blur', function (event) {

				event.preventDefault();

				var x = i.parent().find('input[name=' + i.attr('name') + '-polyfill-field]');

				if (i.val() == '') {

					i.hide();
					x.show();
				}
			});

			x.on('focus', function (event) {

				event.preventDefault();

				var i = x.parent().find('input[name=' + x.attr('name').replace('-polyfill-field', '') + ']');

				x.hide();

				i.show().focus();
			}).on('keypress', function (event) {

				event.preventDefault();
				x.val('');
			});
		});

		// Events.
		$this.on('submit', function () {

			$this.find('input[type=text],input[type=password],textarea').each(function (event) {

				var i = $(this);

				if (i.attr('name').match(/-polyfill-field$/)) i.attr('name', '');

				if (i.val() == i.attr('placeholder')) {

					i.removeClass('polyfill-placeholder');
					i.val('');
				}
			});
		}).on('reset', function (event) {

			event.preventDefault();

			$this.find('select').val($('option:first').val());

			$this.find('input,textarea').each(function () {

				var i = $(this),
				    x;

				i.removeClass('polyfill-placeholder');

				switch (this.type) {

					case 'submit':
					case 'reset':
						break;

					case 'password':
						i.val(i.attr('defaultValue'));

						x = i.parent().find('input[name=' + i.attr('name') + '-polyfill-field]');

						if (i.val() == '') {
							i.hide();
							x.show();
						} else {
							i.show();
							x.hide();
						}

						break;

					case 'checkbox':
					case 'radio':
						i.attr('checked', i.attr('defaultValue'));
						break;

					case 'text':
					case 'textarea':
						i.val(i.attr('defaultValue'));

						if (i.val() == '') {
							i.addClass('polyfill-placeholder');
							i.val(i.attr('placeholder'));
						}

						break;

					default:
						i.val(i.attr('defaultValue'));
						break;

				}
			});
		});

		return $this;
	};

	/**
  * Moves elements to/from the first positions of their respective parents.
  * @param {jQuery} $elements Elements (or selector) to move.
  * @param {bool} condition If true, moves elements to the top. Otherwise, moves elements back to their original locations.
  */
	$.prioritize = function ($elements, condition) {

		var key = '__prioritize';

		// Expand $elements if it's not already a jQuery object.
		if (typeof $elements != 'jQuery') $elements = $($elements);

		// Step through elements.
		$elements.each(function () {

			var $e = $(this),
			    $p,
			    $parent = $e.parent();

			// No parent? Bail.
			if ($parent.length == 0) return;

			// Not moved? Move it.
			if (!$e.data(key)) {

				// Condition is false? Bail.
				if (!condition) return;

				// Get placeholder (which will serve as our point of reference for when this element needs to move back).
				$p = $e.prev();

				// Couldn't find anything? Means this element's already at the top, so bail.
				if ($p.length == 0) return;

				// Move element to top of parent.
				$e.prependTo($parent);

				// Mark element as moved.
				$e.data(key, $p);
			}

			// Moved already?
			else {

					// Condition is true? Bail.
					if (condition) return;

					$p = $e.data(key);

					// Move element back to its original location (using our placeholder).
					$e.insertAfter($p);

					// Unmark element as moved.
					$e.removeData(key);
				}
		});
	};
})(jQuery);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js